<template>
  <el-container class="layout-container">
    <!-- 顶部固定区域 -->
    <el-header class="header-fixed">
      <div class="header-content">
        <!-- <div class="header-left">
          <div class="logo">
            <img src="@/assets/cckLogo.png" alt="Logo" height="40" />
          </div>
        </div> -->
        <div class="header-right">
          <div class="language-selector">
            <i class="yticon icon-zhongyingqiehuan" @click="changeLanguage(locale)"></i>
          </div>
          <div class="user-info">
            <el-avatar :size="40" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" />
            <div class="user-details">
              <!-- 登录状态判断 -->
              <el-dropdown v-if="userStore.userInfo" @command="handleCommand">
                <div class="user-name el-dropdown-link">
                  {{ userStore.userInfo.user_name }}
                  <el-icon><CaretBottom /></el-icon>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>

              <!-- 未登录状态 -->
              <span v-else class="user-name">
                <a :href="BASE_URLS.SSO">请登录</a>
              </span>
              
            </div>
          </div>
        </div>
      </div>
    </el-header>

    <el-container class="main-container">
      <!-- 左侧菜单 -->
      <el-aside :width="isCollapse ? '100px' : '200px'" class="sidebar">
        <div class="logo">
          <img src="@/assets/cck-logo.png" alt="" />
        </div>
        <div class="collapse-btn" @click="isCollapse = !isCollapse">
          <el-icon><Fold v-if="!isCollapse" /><Expand v-else /></el-icon>
        </div>
        <el-menu :collapse="isCollapse" :router="true" :default-active="$route.path" class="menu-container" @select="handleMenuClick">
          <el-menu-item index="/dashboard">
            <el-icon><House /></el-icon>
            <span>{{ t("Menu.homePage") }}</span>
          </el-menu-item>
          <el-menu-item index="/online-office">
            <el-icon><OfficeBuilding /></el-icon>
            <span>{{ t("Menu.work") }}</span>
          </el-menu-item>
          <el-menu-item index="/employee-app">
            <el-icon><User /></el-icon>
            <span>{{ t("Menu.staff") }}</span>
          </el-menu-item>
          <el-menu-item index="/customer-app">
            <el-icon><Service /></el-icon>
            <span>{{ t("Menu.client") }}</span>
          </el-menu-item>
          <el-menu-item index="/system-settings">
            <el-icon><Setting /></el-icon>
            <span>{{ t("Menu.settings") }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <!-- 可选：小屏模式下的快捷入口 -->
      <!-- 右侧内容区 -->
      <el-main class="main-content">
        <transition name="custom-slide" mode="out-in" @before-enter="beforeEnter" @after-enter="afterEnter">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>
<script setup>
import {BASE_URLS} from "@/config/index";
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import Cookies from "js-cookie";
import { useUserStore } from "@/stores/user";
import { getToken } from "@/utils/auth";
import { DropdownInstance, ElMessageBox, ElMessage } from "element-plus";
const userStore = useUserStore();
const router = useRouter();
const isCollapse = ref(false);
const route = useRoute();
const code = route.query.code;
const locale = ref(Cookies.get("locale") || "zh-CN");
import { debounce } from "lodash";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const userInfo = ref(null);

const handleMenuClick = (path) => {
  router.push(path);
};
const handleCommand=(command)=> {
    if (command === 'logout') {
      userStore.logout();
    }
}
const changeLanguage = (lang) => {
  if (lang === "zh-CN") {
    locale.value = "en"; // 设置当前语言为中文
  } else {
    locale.value = "zh-CN"; // 设置当前语言为越南语
  }
  localStorage.setItem("locale", locale.value);
  Cookies.set("locale", locale.value, { expires: 7 });
  router.go(0);
};
// 添加滚动锁定逻辑
let scrollLock = false;

const beforeLeave = (el) => {
  el.style.opacity = 0;
  el.style.transform = "translateX(0)"; // 初始位置重置
  requestAnimationFrame(() => {
    el.style.transform = "translateX(100%)";
  });
};

const afterEnter = (el) => {
  el.style.opacity = 1;
  el.style.transform = "translateX(0)";
  setTimeout(() => {
    document.body.style.overflow = ""; // 解锁滚动条
    scrollLock = false;
  }, 500); // 延迟解锁保证动画完成
};
// 监听窗口大小变化
const handleResize = debounce(() => {
  isCollapse.value = window.innerWidth <= 600;
}, 100);

onMounted(() => {
  handleLogin();
  handleResize();
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
const handleLogin = async () => {
  const token = getToken();
  try {
    if (!token || token === "undefined") {
      // 无 Token 时才需要登录
      await userStore.login(route.query.code);
    } else {
      await userStore.fetchUserInfo();
      userInfo.value = userStore.userInfo;
    }
  } catch (err) {
    ElMessageBox.confirm("登录失败要重新登录嘛", "Warning", {
      confirmButtonText: "重新登录",
      cancelButtonText: "关闭",
      type: "温馨提示",
    })
      .then(() => {
         window.location.href = BASE_URLS.SSO;
       })
      .catch(() => {});
    console.error("登录失败:", err);
  }
};

const dropdown1 = ref("");
const showClick = () => {
  if (!dropdown1.value) return;
  dropdown1.value.handleOpen();
};
</script>

<style scoped lang="scss">

/* 针对 WebKit 浏览器（Chrome/Safari/Edge） */
main::-webkit-scrollbar,
aside::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}
.el-dropdown-link {
  display: flex;
  align-items: center;
  gap: 20px; /* 图标与文字间距 */
}

.el-popper {
  border-radius: 4px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}
/* 针对 Firefox */
main,
aside {
  scrollbar-width: none; /* Firefox 64+ */
  -ms-overflow-style: none; /* IE 11 */
}
/* 可选：优化移动端体验 */
@media (max-width: 600px) {
  .collapse-btn {
    display: none !important;
  }
}
// 重要样式必须使用 !important 强制覆盖
.custom-slide-leave-active {
  animation: pageOut 0.3s forwards cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
}

.custom-slide-enter-active {
  animation: pageIn 0.3s forwards cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
}

@keyframes pageOut {
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

@keyframes pageIn {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.layout-container {
  height: 100vh;
  width: 100%;
  height: 100%;
  .header-fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    height: 60px;
    padding: 0;
    background-color: #fff;
    box-shadow: -2px 0px 16px 2px rgba(243, 235, 237, 0.16);

    .header-content {
      width: 80%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      // .header-left {
      //   display: flex;
      //   align-items: center;

      //   .logo {
      //     display: flex;
      //     align-items: center;
      //     img {
      //       margin-left: 20px;
      //     }

      //     span {
      //       font-size: 18px;
      //       font-weight: bold;
      //       color: #303133;
      //     }
      //   }
      // }

      .header-right {
        display: flex;
        align-items: flex-end;
        .language-selector {
          margin-right: 20px;
          cursor: pointer;
        }

        .user-info {
          display: flex;
          align-items: center;

          .user-details {
            margin-left: 10px;
            display: flex;
            flex-direction: column;

            .user-name {
              font-size: 14px;
              font-weight: bold;
              color: #303133;
            }

            .user-role {
              font-size: 12px;
              color: #909399;
            }
          }
        }
      }
    }
  }

  .main-container {
    width: 100%;
    margin: 0 auto;
    margin-top: 60px;
    height: calc(100vh - 60px);
    .sidebar {
      transition: width 0.7s;
      // height: 100%;
      background: #ffffff;
      padding: 0 20px;
      .collapse-btn {
        height: 50px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #000000;
        font-size: 20px;
        padding: 0 var(--el-menu-base-level-padding);
      }

      .menu-container {
        border-right: none;
      }
      .el-menu-item.is-active {
        color: #000000;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        position: relative;
        i {
          color: #ba0001;
        }
      }
      .logo {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }

    .main-content {
      width: 90%;
      margin: 0 auto;
      padding: 20px;
      background: #f9fbfc url("@/assets/mainbg.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
.el-menu-item.is-active::before {
  content: "";
  position: absolute;
  left: -13%;
  top: 46%;
  width: 17px;
  height: 6px;
  background: #ba0001;
  border-radius: 0px 2.5px 2.5px 0px;
}
:deep(.el-dropdown-link) {
  cursor: pointer;
  display: flex;
  align-items: center;
}
// .el-menu {
//   background: none;
// }
</style>
